import { StateCreator } from 'zustand';
import type { Theme, Toast } from '@/types/common';

export interface UIState {
  theme: Theme;
  sidebarCollapsed: boolean;
  toasts: Toast[];
  tradingActivityTimezone: string;
}

export interface UIActions {
  setTheme: (theme: Theme) => void;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  addToast: (toast: Omit<Toast, 'id'>) => void;
  removeToast: (id: string) => void;
  setTradingActivityTimezone: (tz: string) => void;
}

export type UISlice = {
  ui: UIState & UIActions;
};

const initialState: UIState = {
  theme: 'dark',
  sidebarCollapsed: false,
  toasts: [],
  tradingActivityTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

export const createUISlice: StateCreator<UISlice> = (set) => ({
  ui: {
    ...initialState,

    setTheme: (theme) =>
      set((state) => ({
        ui: { ...state.ui, theme },
      })),

    toggleSidebar: () =>
      set((state) => ({
        ui: { ...state.ui, sidebarCollapsed: !state.ui.sidebarCollapsed },
      })),

    setSidebarCollapsed: (collapsed) =>
      set((state) => ({
        ui: { ...state.ui, sidebarCollapsed: collapsed },
      })),

    addToast: (toast) =>
      set((state) => ({
        ui: {
          ...state.ui,
          toasts: [...state.ui.toasts, { ...toast, id: Date.now().toString() }],
        },
      })),

    removeToast: (id) =>
      set((state) => ({
        ui: {
          ...state.ui,
          toasts: state.ui.toasts.filter((t) => t.id !== id),
        },
      })),

    setTradingActivityTimezone: (tz) =>
      set((state) => ({
        ui: { ...state.ui, tradingActivityTimezone: tz },
      })),
  },
});
